import React from 'react'

const SiniestroAutomotor = ({iconContactoMasculino}) => {
   return (
      <>
         <div className="section animated fadeIn">
            <div className="bg-latitud animated fadeIn" style={{ "marginBottom": "30px", borderRadius: "8px", backgroundColor: "#039be5", padding: "15px" }}>
               <div className="container section center white-text" style={{ padding: "0" }}>
                  <h5 style={{ margin: 0, fontWeight: '600' }}>
                     <strong>Siniestro Automotor</strong>
                  </h5>
               </div>
            </div>

            <div className="row">
               <div className="col s12 m12 l6 x6">
                  <div className="card-panel white z-depth-1 hoverable" style={{ borderRadius: '8px', borderLeft: '4px solid #039be5', padding: '20px' }}>
                     <div className="row valign-wrapper mb-0">
                        <div className="col s3 m2">
                           <img src={iconContactoMasculino} alt="" className="circle responsive-img"/>
                        </div>
                        <div className="col s9 m10">
                           <span className="grey-text text-darken-3" style={{ lineHeight: '1.6', display: 'block' }}>
                              <strong className="light-blue-text text-darken-2" style={{ fontSize: '1.1rem' }}>Pablo Balencia</strong><br/>
                              <span style={{ fontSize: '0.95rem' }}>0388 - 156 859 269</span><br/>
                              <span style={{ fontSize: '0.95rem' }}>0388 - 4911741 Int.: 131</span><br/>
                              <a href="mailto:pbalencia@latitudsursa.com.ar" className="light-blue-text text-darken-2" style={{ fontSize: '0.95rem' }}>pbalencia@latitudsursa.com.ar</a>
                           </span>
                        </div>
                     </div>
                  </div>
               </div>

               <div className="col s12 m12 l6 x6">
                  <div className="card-panel white z-depth-1 hoverable" style={{ borderRadius: '8px', borderLeft: '4px solid #039be5', padding: '20px' }}>
                     <div className="row valign-wrapper mb-0">
                        <div className="col s3 m2">
                           <img src={iconContactoMasculino} alt="" className="circle responsive-img"/>
                        </div>
                        <div className="col s9 m10">
                           <span className="grey-text text-darken-3" style={{ lineHeight: '1.6', display: 'block' }}>
                              <strong className="light-blue-text text-darken-2" style={{ fontSize: '1.1rem' }}>Alejandro Mamani</strong><br/>
                              <span style={{ fontSize: '0.95rem' }}>0388 - 155 174 304</span><br/>
                              <span style={{ fontSize: '0.95rem' }}>0388 - 4911741 Int.: 133</span><br/>
                              <a href="mailto:pmamani@latitudsursa.com.ar" className="light-blue-text text-darken-2" style={{ fontSize: '0.95rem' }}>pmamani@latitudsursa.com.ar</a>
                           </span>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}

export default SiniestroAutomotor